import { connect } from 'react-redux';
import * as UIActions from '../actions';
import { UiEventHandlersComponent } from '../components/UiEventHandlers';
import { UI_STATES } from '../reducers';

const mapStateToProps = (state) => ({
  uiState: state.ui.state,
});

const mapDispatchToProps = (dispatch) => ({
  canTouch: () => dispatch(UIActions.canTouch()),
  setControlsUIState: () => dispatch(UIActions.setState(UI_STATES.CONTROLS)),
  setIdleUIState: () => dispatch(UIActions.setState(UI_STATES.IDLE)),
});

export const UiEventHandlers = connect(
  mapStateToProps,
  mapDispatchToProps,
)(UiEventHandlersComponent);
